import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color, opacity = 1, strokeWidth }) => (
  <>
    <path
      id="NetlyncIconChain"
      d="M14.785 9.7c-.064 3.312-1.855 5.02-4.064 5.02H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h6.72a4 4 0 0 1 4 4v1.01"
      transform="matrix(8.815 0 0 8.670 32.448 32.274)"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth / 8.5}
    />
    <use
      transform="rotate(180 128 128)"
      xlinkHref="#NetlyncIconChain"
      opacity={opacity}
    />
  </>
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} opacity={0.2} />],
    ['fill', <Icon color={color} strokeWidth={16} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={16} />],
  ]);

export const Netlync = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
  />
));

Netlync.displayName = 'Netlync';
